export enum DetailsNavigationStep {
  INITIAL_INFORMATION = 1,
  OTP = 2,
  PERSONAL_INFORMATION = 3,
  ADDRESS = 4,
  FINANCIAL_INFORMATION = 5
}
